export default __webpack_public_path__ + "static/media/6.62b9cbf1.png";